<template>
    <diverse-input ref="di" v-bind="$attrs" :value.sync="localValue" :config="config"
                   @enter="emitEnterEvent"></diverse-input>
</template>

<script>
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";

export default {
    name: "MiniInput",
    components: {DiverseInput},
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        label: String,
        type: String,
        value: null,
        require: Boolean,
        options: Array,
        optionsFromDict: String,
        selectDictText: Boolean,
    },
    data() {
        return {
            localValue: this.value
        }
    },
    watch: {
        localValue() {
            this.$emit('update:value', this.localValue);
            this.$emit('change', this.localValue);
        },
        value: {
            handler() {
                this.localValue = this.value;
            },
            immediate: true
        }
    },
    computed: {
        config() {
            return {
                label: this.label,
                type: this.type,
                require: this.require,
                options: this.options,
                optionsFromDict: this.optionsFromDict,
                selectDictText: this.selectDictText,
            }
        },
    },
    mounted() {
        if (this.optionsFromDict) {
            this.$store.dispatch('dictionaryEnumStore/queryDictionary', this.optionsFromDict);
        }
    },
    methods: {
        focus() {
            this.$refs.di.focus();
        },
        emitEnterEvent() {
            this.$nextTick(() => this.$emit('enter'));
        },
    }
}
</script>

<style scoped>

</style>
